import { useEffect, useState } from "react";
import { getFooterModel } from "../../../../api/footerApi";
import { FooterData } from "../../../../api/footerApi.types";

export const useFooterData = (currentPageId: number, initialData?: FooterData) => {
  const [footerData, setFooterData] = useState<FooterData>(initialData ?? null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (initialData) {
      return;
    }

    const fetchContent = async () => {
      setLoading(true);

      const result = await getFooterModel(currentPageId);

      setFooterData(result);
      setLoading(false);
    };

    fetchContent();
  }, [currentPageId]);

  return { footerData, loading };
};
